import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'projects/datexapplication/src/environments/environment';
import { Observable } from 'rxjs';

export enum AnalysisType {
  Performance,
  Security,
  BestPractices,
  Logic
}

export interface IAnalysisResult {
  finding: IAnalysisFinding[];
}

export interface IAnalysisFinding {
  lineNumber: string;
  description: string;
  severity: number;
  suggestion: string;
  code: string;
  selected: boolean;
  completed: boolean;
  hovering: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class CopilotService {

  // Changed temporairly to be able to compile
  private baseUrl = environment.copilotApiUrl;

  constructor(private http: HttpClient) { }

  public analyzeFlow(type: AnalysisType, flowScript: string): Observable<IAnalysisResult> {
    const url = `${this.baseUrl}${AnalysisType[type]}`;
    return this.http.post<IAnalysisResult>(url, flowScript);
  }
}
